"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showProgressToast = exports.showMessageOnWarn = exports.showMessageOnError = exports.showMessageOnSuccess = exports.updateToastRef = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const progressbar_1 = require("primereact/progressbar");
let toastRef = (0, react_1.createRef)();
const updateToastRef = (ref) => {
    toastRef = ref;
    // console.log('>>>>toastRef updated<<<< Not null: ', toastRef !== null);
};
exports.updateToastRef = updateToastRef;
function showMessageOnSuccess(title, message) {
    if (toastRef && toastRef.current)
        toastRef.current.show({
            severity: 'success',
            summary: title,
            detail: message,
            life: 4000
        });
}
exports.showMessageOnSuccess = showMessageOnSuccess;
function showMessageOnError(title, message) {
    if (toastRef && toastRef.current)
        toastRef.current.show({
            severity: 'error',
            summary: title,
            detail: message,
            sticky: true
        });
}
exports.showMessageOnError = showMessageOnError;
function showMessageOnWarn(title, message, duration) {
    if (toastRef && toastRef.current)
        toastRef.current.show({
            severity: 'warn',
            summary: title,
            detail: message,
            life: duration ? duration : 5000
        });
}
exports.showMessageOnWarn = showMessageOnWarn;
function showProgressToast(value) {
    if (toastRef && toastRef.current)
        return toastRef;
    toastRef.current.show({
        severity: 'warn',
        sticky: true,
        content: ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "flex flex-column", style: { flex: '1' } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "text-center" }, { children: [(0, jsx_runtime_1.jsx)("i", { className: "pi pi-exclamation-triangle", style: { fontSize: '2rem' } }), (0, jsx_runtime_1.jsx)("h4", { children: "L\u00FCfter wurde gestoppt. Bitte warten." }), (0, jsx_runtime_1.jsx)(progressbar_1.ProgressBar, { value: value })] })) })))
    });
}
exports.showProgressToast = showProgressToast;
